import React from "react";
import Commons from '../../util/commons';
var { QRCodeSVG: QRCode } = require('qrcode.react');

class ModernTemplateComponent extends React.Component {

    wrapText = (text, maxCharsPerLine = 80) => {
        if (!text) return '';
        return text.split('\n').map(line => {
            if (line.length <= maxCharsPerLine) return line;
            const words = line.split(' ');
            const wrappedLines = [];
            let current = '';
            for (const word of words) {
                if ((current + (current ? ' ' : '') + word).length > maxCharsPerLine && current) {
                    wrappedLines.push(current);
                    current = word;
                } else {
                    current = current ? current + ' ' + word : word;
                }
            }
            if (current) wrappedLines.push(current);
            return wrappedLines.join('\n');
        }).join('\n');
    }

    qrcodeValue = (invoiceUid) => {
        return window.location.host + "/mydata/" + invoiceUid;
    }

    getLogo = (logo) => {
        if (logo) {
            if (!logo.includes("blob:")) logo += "?" + Date.now();
            return <img alt="" src={logo} className="t-logo" />;
        }
    }

    createMoreTaxesTable(saleInstanceMoreTaxes, lang) {
        var rows = [];
        var types = [];
        saleInstanceMoreTaxes.sort((a, b) => a.myDataMoreTax.type.localeCompare(b.myDataMoreTax.type));
        saleInstanceMoreTaxes.forEach(e => {
            var type = e.myDataMoreTax.type;
            if (type === "DEDUCTION" && e.myDataMoreTax.label) {
                e.deduction = e.myDataMoreTax;
                e.deduction.name = e.myDataMoreTax.label;
            }
            if (e.deduction) type = "DEDUCTION";
            if (!types.includes(e.myDataMoreTax.type)) {
                types.push(e.myDataMoreTax.type);
            } else {
                type = "";
            }
            var TAX = e.myDataMoreTax ? "TAX_" + e.myDataMoreTax.uid : null;
            if (e.deduction) {
                rows.push(<tr key={Math.random()} className="t-tax-row"><td>{this.props.t(type, { lng: lang })}</td><td>{e.deduction.name}</td><td className="t-td-r">{e.amount}</td></tr>);
            } else {
                rows.push(<tr key={Math.random()} className="t-tax-row"><td>{this.props.t(type, { lng: lang })}</td><td>{this.props.t(TAX, { lng: lang })}</td><td className="t-td-r">{e.amount}</td></tr>);
            }
        });
        return rows;
    }

    createEntries = (entries) => {
        var rows = [];
        if (!entries) return rows;
        entries = entries.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0));
        const sale = this.props.sale;
        const lang = sale ? sale.TEMPLATE_LANG : undefined;
        const showMu = sale ? !Commons.isOnGroup(sale.MYDATA_INVOICE_TYPE, "noMeasurementUnit") : true;

        entries.forEach(entry => {
            const isEmpty = !entry.NAME_LIST;
            rows.push(
                <tr key={"entry_" + entry.id} className={isEmpty ? "t-row t-row-empty" : "t-row"}>
                    <td className="t-td-name"><small>{entry.NAME_LIST}</small></td>
                    <td className="t-td-r">{entry.QUANTITY_LIST}</td>
                    {showMu && <td className="t-td-r">{this.props.t(entry.MU_LIST, { lng: lang })}</td>}
                    <td className="t-td-r">{entry.UP_LIST}</td>
                    <td className="t-td-r">{entry.DISCOUNT}</td>
                    <td className="t-td-r">{entry.VAT_LIST}{entry.VAT_LIST ? "%" : ""}</td>
                    <td className="t-td-r">{entry.PRICE_NOVAT_LIST}</td>
                    <td className="t-td-r t-td-total">{entry.PRICE_LIST}</td>
                </tr>
            );
        });
        return rows;
    }

    createPage = (sale) => {
        const lang = sale.TEMPLATE_LANG;
        const t = (key, opts) => this.props.t(key, { lng: lang, ...opts });
        const showMu = !Commons.isOnGroup(sale.MYDATA_INVOICE_TYPE, "noMeasurementUnit");
        const showMove = sale.MOVE_PURPOSE || sale.VEHICLE_NUMBER || sale.DISPATCH_DATE || sale.LOADING_ADDRESS || sale.DELIVERY_ADDRESS;

        return (
            <div className="t-invoice-box" key={"box_" + Math.floor(Math.random() * 10000)}>

                {/* ── HEADER ── */}
                <div className="t-header">
                    <div className="t-header-logo-wrap">
                        {this.getLogo(sale.LOGO)}
                    </div>
                    <div className="t-header-issuer">
                        <div className="t-issuer-name">{sale.ISSUER_NAME}</div>
                        {sale.ISSUER_SUBJECTFIELD && <div className="t-issuer-sub">{sale.ISSUER_SUBJECTFIELD}</div>}
                        <div className="t-issuer-meta">
                            {sale.ISSUER_ADDRESS && <span>{sale.ISSUER_ADDRESS}</span>}
                            {sale.ISSUER_VAT && <span className="t-meta-sep">{t("TAXPAYER_ID")}: {sale.ISSUER_VAT}</span>}
                            {sale.ISSUER_DOY && <span className="t-meta-sep">{t("DOY")}: {sale.ISSUER_DOY}</span>}
                            {sale.ISSUER_GEMH && <span className="t-meta-sep">{t("GEMH")}: {sale.ISSUER_GEMH}</span>}
                        </div>
                        <div className="t-issuer-meta">
                            {sale.ISSUER_PHONE && <span>{t("PHONE")}: {sale.ISSUER_PHONE}</span>}
                            {sale.ISSUER_EMAIL && <span className="t-meta-sep">{t("EMAIL")}: {sale.ISSUER_EMAIL}</span>}
                        </div>
                    </div>
                    <div className="t-header-badge">
                        <div className="t-badge-type">{sale.INVOICE_TYPE}</div>
                        <div className="t-badge-number">{sale.INVOICE_NUMBER}</div>
                        <div className="t-badge-date-lbl">{t("IssueDate")}</div>
                        <div className="t-badge-date">{sale.INVOICE_DATE}</div>
                        {sale.INVOICE_TIME && <div className="t-badge-time">{sale.INVOICE_TIME}</div>}
                    </div>
                </div>
                <div className="t-gold-bar"></div>

                {/* ── PARTIES ── */}
                <div className="t-parties">
                    <div className="t-party">
                        <div className="t-party-label">{t("customerSection")}</div>
                        <div className="t-party-name">{sale.CP_NAME}</div>
                        {sale.CP_SUBJECT_FIELD && <div className="t-party-row">{sale.CP_SUBJECT_FIELD}</div>}
                        {sale.CP_ADDRESS && <div className="t-party-row">{sale.CP_ADDRESS}</div>}
                        {(sale.CP_CITY || sale.COUNTRY) && (
                            <div className="t-party-row">{sale.CP_CITY}{sale.COUNTRY ? ", " + t(sale.COUNTRY) : ""}</div>
                        )}
                        {sale.CP_VAT && <div className="t-party-row"><span className="t-lbl">{t("TAXPAYER_ID")}:</span> {sale.CP_VAT}</div>}
                        {sale.CP_TAXOFFICE && <div className="t-party-row"><span className="t-lbl">{t("DOY")}:</span> {sale.CP_TAXOFFICE}</div>}
                        {sale.CP_PAYTYPE && <div className="t-party-row"><span className="t-lbl">{t("CP_PAYTYPE")}:</span> {t(sale.CP_PAYTYPE)}</div>}
                    </div>
                    {showMove && (
                        <div className="t-party t-party-transport">
                            <div className="t-party-label">{t("moveSection")}</div>
                            {sale.MOVE_PURPOSE && <div className="t-party-row"><span className="t-lbl">{t("MOVE_PURPOSE")}:</span> {sale.MOVE_PURPOSE}</div>}
                            {sale.VEHICLE_NUMBER && <div className="t-party-row"><span className="t-lbl">{t("VEHICLE_NUMBER")}:</span> {sale.VEHICLE_NUMBER}</div>}
                            {sale.DISPATCH_DATE && <div className="t-party-row"><span className="t-lbl">{t("DISPATCH_DATE")}:</span> {sale.DISPATCH_DATE}</div>}
                            {sale.LOADING_ADDRESS && <div className="t-party-row"><span className="t-lbl">{t("LOADING_ADDRESS")}:</span> {sale.LOADING_ADDRESS}</div>}
                            {sale.DELIVERY_ADDRESS && <div className="t-party-row"><span className="t-lbl">{t("DELIVERY_ADDRESS")}:</span> {sale.DELIVERY_ADDRESS}</div>}
                        </div>
                    )}
                </div>

                {/* ── PRODUCT TABLE ── */}
                <div className="t-table-wrap">
                    <table className="t-product-table">
                        <thead>
                            <tr>
                                <th className="t-th-name">{t("PROD_SERV")}</th>
                                <th className="t-th-r">{t("QUANTITY")}</th>
                                {showMu && <th className="t-th-r">{t("MUN")}</th>}
                                <th className="t-th-r">{t("UNIT_PRICE")}</th>
                                <th className="t-th-r">{t("DISCOUNT")}</th>
                                <th className="t-th-r">{t("VAT")} %</th>
                                <th className="t-th-r">{t("PRICE_WITHOUT_VAT")}</th>
                                <th className="t-th-r">{t("PRICE_WITH_VAT")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.createEntries(sale.entries)}
                        </tbody>
                    </table>
                </div>

                {/* ── BOTTOM (pinned to page bottom) ── */}
                <div className="t-bottom-section">
                <div className="t-footer-section">
                    <div className="t-footer-left">
                        <div className="t-notes-block">
                            <div className="t-block-lbl">{t("NOTES")}</div>
                            <div className="t-notes-text" style={{ whiteSpace: 'pre-wrap' }}>{this.wrapText(sale.NOTES)}</div>
                        </div>
                        {sale.saleInstanceMoreTaxes && sale.saleInstanceMoreTaxes.length > 0 && (
                            <table className="t-moretax-table">
                                <tbody>
                                    {this.createMoreTaxesTable(sale.saleInstanceMoreTaxes, lang)}
                                </tbody>
                            </table>
                        )}
                        <div className="t-qr-wrap">
                            <QRCode
                                size={72}
                                bgColor="#ffffff"
                                fgColor={this.props.mainStyle ? (this.props.mainStyle.match(/--appcolor:\s*([^;]+)/)?.[1]?.trim() || "#1a2c6b") : "#1a2c6b"}
                                level="L"
                                marginSize={0}
                                value={sale.QRURL ? sale.QRURL : this.qrcodeValue(sale.INVOICEUID)}
                            />
                        </div>
                    </div>

                    <div className="t-footer-right">
                        {!Commons.isOnGroup(sale.MYDATA_INVOICE_TYPE, "noCountItems") && (
                            <div className="t-count-items">
                                {t("TOTALITEMS")}: <strong>{sale.TOTALCOUNTITEMS}</strong>
                            </div>
                        )}
                        <table className="t-totals-table">
                            <tbody>
                                <tr>
                                    <td>{t("TOTALVALUE")}</td>
                                    <td className="t-td-r">{sale.TOTALNODISCOUNT}</td>
                                </tr>
                                <tr>
                                    <td>{t("DISCOUNT")}</td>
                                    <td className="t-td-r">{sale.TOTALDISCOUNT}</td>
                                </tr>
                                <tr>
                                    <td>{t("VATVALUE")}</td>
                                    <td className="t-td-r">{sale.TOTALVAT}</td>
                                </tr>
                                {sale.TOTALTAXES && (
                                    <tr>
                                        <td>{t("MORETAXES")}</td>
                                        <td className="t-td-r">{sale.TOTALTAXES}</td>
                                    </tr>
                                )}
                                <tr className="t-total-final">
                                    <td>{t("PAYAMOUNT")}</td>
                                    <td className="t-td-r">{sale.TOTALPAYMENT}</td>
                                </tr>
                                {sale.CURRENCY && sale.CURRENCY !== "EUR" && (
                                    <tr>
                                        <td>{t("TOTALPAYMENT_ON_CURRENCY", { currency: sale.CURRENCY })}</td>
                                        <td className="t-td-r">{sale.TOTALPAYMENT_ON_CURRENCY} <span className="t-currency">{sale.CURRENCY}</span></td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        {sale.IBAN && <div className="t-iban">{sale.IBAN}</div>}
                        <div className="t-signatures">
                            <div className="t-sign-box">
                                <div className="t-sign-lbl">{t("ISSUANCE")}</div>
                                <div className="t-sign-line"></div>
                                <div className="t-sign-sub">{t("Signature")}</div>
                            </div>
                            <div className="t-sign-box">
                                <div className="t-sign-lbl">{t("RECEIPT")}</div>
                                <div className="t-sign-line"></div>
                                <div className="t-sign-sub">{t("Signature")}</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ── EXTRA INFO ── */}
                {(sale.VAT_EXCEPTION_CATEGORIES?.[0] || sale.MOREINFO || sale.CORRELATIVE_INVOICE) && (
                    <div className="t-extra-info">
                        {sale.VAT_EXCEPTION_CATEGORIES?.[0] && (
                            <div><small><strong>{t("vatCategoryExceptionShort")}:</strong> {t(sale.VAT_EXCEPTION_CATEGORIES[0])}</small></div>
                        )}
                        {sale.MOREINFO && <div>{t(sale.MOREINFO)}</div>}
                        {sale.CORRELATIVE_INVOICE && <div><small>{t("correlativeSales")} {t(sale.CORRELATIVE_INVOICE)}</small></div>}
                    </div>
                )}

                {/* ── MYDATA FOOTER ── */}
                <div className="t-mydata-footer">
                    <div className="t-mydata-row">
                        {sale.INVOICEUID && (
                            <span><span className="t-mydata-lbl">uid:</span> <span className="t-mydata-val">{sale.INVOICEUID}</span></span>
                        )}
                        {sale.INVOICEMARK
                            ? <span><span className="t-mydata-lbl">mark:</span> <span className="t-mydata-val">{sale.INVOICEMARK}</span></span>
                            : <span className="t-not-published">{t("notPublished")}</span>
                        }
                        {sale.CANCELATIONMARK && (
                            <span><span className="t-mydata-lbl">cancelationMark:</span> <span className="t-mydata-val">{sale.CANCELATIONMARK}</span></span>
                        )}
                    </div>
                    <div className="t-createdby">{t("CREATEDBY")}</div>
                </div>
                </div>{/* end t-bottom-section */}

            </div>
        );
    }

    createPages = (sale) => {
        var pages = [];
        var chunk = 18;
        if (sale && sale.INVOICE_ENTRIES != undefined) {
            for (var i = 0, j = sale.INVOICE_ENTRIES.length; i < j; i += chunk) {
                var groupEntries = sale.INVOICE_ENTRIES.slice(i, i + chunk);
                var groupSale = Object.assign({}, sale, { entries: groupEntries });
                pages.push(this.createPage(groupSale));
            }
        }
        return pages;
    }

    getMainStyle = () => {
        if (this.props.mainStyle) return <style>{this.props.mainStyle}</style>;
    }

    getExtraCss = () => {
        if (this.props.extracss) return <style>{this.props.extracss}</style>;
    }

    render() {
        return (
            <div id="template_page" className="page template_page">
                <link type="text/css" rel="stylesheet" href="../template-modern.css" />
                <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap" rel="stylesheet" type="text/css" />
                {this.getMainStyle()}
                {this.getExtraCss()}
                {this.createPages(this.props.sale)}
            </div>
        );
    }
}

export default ModernTemplateComponent;
